import React from 'react';
import { useTranslation } from "react-i18next";
import './ProfileComponent.css';
import defaultAvatar from './user-avatar.png';  // Path to the default avatar

// const roleMapping = {
//   PA: "Patient",
//   AD: "Admin",
//   DO: "Practitioner",
//   CA: "Clinic Admin"
// };

const ProfileComponent = ({ user }) => {
  const { t } = useTranslation();

  // Full name combination
  const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();

  return (
    <div className="profile-container">
      <h2 className="profile-title">{t("profile.my_profile")}</h2>

      {/* Profile Picture */}
      <div className="profile-picture-container">
        <img src={defaultAvatar} alt="Profile" className="profile-picture" />
      </div>

      {/* Profile Details */}
      <div className="profile-details">
        {/* Name Field */}
        <div className="profile-field">
          <span className="field-label">{t("profile.name")}:</span>
          <span className="field-value">{fullName || 'N/A'}</span>
        </div>

        {/* Role Field */}
        {/* <div className="profile-field">
          <span className="field-label">{t("profile.role")}:</span>
          <span className="field-value">{roleMapping[user.role] || "N/A"}</span>
        </div> */}

        {/* Clinic Name (Visible only for Clinic Admins) */}
        {(user.role === "CA" || user.role === "AD") && (
          <div className="profile-field">
            <span className="field-label">{t("profile.clinic_name")}:</span>
            <span className="field-value">{user.clinic_name || 'N/A'}</span>
          </div>
        )}

        {/* Username Field */}
        {/* <div className="profile-field">
          <span className="field-label">Username:</span>
          <span className="field-value">{user.username || 'N/A'}</span>
        </div> */}

        {/* Email Field */}
        <div className="profile-field">
          <span className="field-label">{t("profile.email")}:</span>
          <span className="field-value">{user.email || 'N/A'}</span>
        </div>

        {/* Phone Field */}
        <div className="profile-field">
          <span className="field-label">{t("profile.phone")}:</span>
          <span className="field-value">{user.phone || 'N/A'}</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
